import React from 'react'
import Layout from './src/widgets/Layout'

const GTM_ID = 'GTM-PSCNPBG';

const injectGtm = () => {
  if (typeof window === 'undefined' || window.__gtmLoaded) {
    return;
  }

  window.__gtmLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
    platform: 'gatsby',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
};

const onClientEntry = () => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const loadOnInteraction = () => {
    injectGtm();
    window.removeEventListener('scroll', loadOnInteraction, listenerOptions);
    window.removeEventListener('pointerdown', loadOnInteraction, listenerOptions);
    window.removeEventListener('keydown', loadOnInteraction, listenerOptions);
    window.removeEventListener('touchstart', loadOnInteraction, listenerOptions);
  };

  const listenerOptions = { passive: true, once: true };
  window.addEventListener('scroll', loadOnInteraction, listenerOptions);
  window.addEventListener('pointerdown', loadOnInteraction, listenerOptions);
  window.addEventListener('keydown', loadOnInteraction, listenerOptions);
  window.addEventListener('touchstart', loadOnInteraction, listenerOptions);

  // Backstop so analytics still starts for passive sessions.
  window.setTimeout(injectGtm, 8000);
};

const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

export {
  onClientEntry,
  wrapPageElement
}
